import { Component, OnInit } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MessagesService } from 'src/app/services/messages.service';
import { UserService } from 'src/app/services/user.service';
import { getToken } from 'src/app/shared/global';
import { Address } from 'src/app/models/Address';

@Component({
  selector: 'app-login-avet',
  templateUrl: './login-avet.component.html',
  styleUrls: ['./login-avet.component.scss']
})
export class LoginAvetComponent implements OnInit {

  public url: UrlTree;
  public nid: string;
  public token: string;
  public listaAddresses: Address[] = [];
  public listaRoles: string[] = [];

  constructor(private router: Router, private authService: AuthenticationService, private mensajesService: MessagesService, 
    private spinner: NgxSpinnerService, private toastr: ToastrService, private userService: UserService) { }

  ngOnInit() {
    // Obtenemos los parámetros de la URL
    this.url = this.router.parseUrl(this.router.url);
    this.nid = this.url.queryParams['nid'];
    this.token = this.url.queryParams['token'];
    let data = {
      token: this.token,
      nid: this.nid
    };

    if (getToken(data) || this.authService.isUserLoggedIn()){
      this.getUserInfo();
    }
  }

  getUserInfo() {
    this.spinner.show();    
    this.userService.getUser(this.nid).subscribe(
      data => {
        if (getToken(data)) {
          localStorage.setItem("nid", data.nid);
          localStorage.setItem("firstName",data.firstName);
          localStorage.setItem("lastName",data.lastName);
          localStorage.setItem("phone",data.phone);
          localStorage.setItem("email",data.email);
          localStorage.setItem("active",data.active.toString());
          if(data.addresses!=null){
            for (let i = 0; i < data.addresses.length; i++) {
              this.listaAddresses.push(data.addresses[i]);
            }
            
            localStorage.setItem("addresses",JSON.stringify(this.listaAddresses));
          }else{
            localStorage.setItem("addresses",JSON.stringify(this.listaAddresses));
          }
          
          for (let i = 0; i < data.role.length; i++) {
            this.listaRoles.push(data.role[i].name);
          }

          localStorage.setItem("roles", JSON.stringify(this.listaRoles));
		  
          if(data.role.length===1){
            localStorage.setItem("role", data.role[0].name);
            localStorage.setItem("numberRole", data.role.length.toString());
            this.router.navigate(['home']);          
          }else{
            localStorage.setItem("numberRole", data.role.length.toString());
            this.router.navigate(['menu-role']);
          }
          
          this.spinner.hide();
        } else {
          let infoUser = {
            userName: localStorage.getItem("nid")
          }
          this.authService.logOut(infoUser).subscribe(
            data => {
              localStorage.clear();
              this.router.navigate(['login']);
            },
            error => {
              this.router.navigate(['login']);
            }
          );
        }
      }, error => {
        let infoUser = {
          userName: localStorage.getItem("nid")
        }
        this.authService.logOut(infoUser).subscribe(
          data => {
            localStorage.clear();
            this.router.navigate(['login']);
          },
          error => {
            this.router.navigate(['login']);
          }
        );
      })
  }

}
